import { render, staticRenderFns } from "./ProductsTable.vue?vue&type=template&id=2b40b009&"
import script from "./ProductsTable.vue?vue&type=script&lang=ts&"
export * from "./ProductsTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports